import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=7bc9a5a2&"
var script = {}
import style0 from "./AddButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports